import {CircularProgress, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {
    Button,
    DateInput,
    FormWithRedirect,
    Identifier,
    required,
    SelectInput,
    TextInput,
    useListContext,
    useNotify,
    useRefresh,
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import {useState} from "react";
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import {useToggler} from "../../../shared/hooks/useToggler";
import {client} from "../../../dataProvider";
import {dateFormatter, generateError, initInput} from "../../../shared/utils";
import {useOptions} from "../../../shared/hooks/useOptions";
import {FormSaveButton} from "../../../components/FormSaveButton";
import {BiCalendar} from "react-icons/bi";

export const ChangePaymentScheduleExpiredDateBulkButton = ({ ids }: { ids?: Identifier[] }) => {
  const { selectedIds, refetch, data } = useListContext();


  const [loading, setLoading] = useState(false);

  const { value, setFalse, setTrue } = useToggler();
  const notify = useNotify();
  const handleSubmit = (values: any) => {
    setLoading(true);

    client(`payment_schedule_status/update_expiration_date_bulk`, {
      method: "POST",
      data: {
        ids: selectedIds,
        ...values
      }
    }).then((response) => {
      notify("Fatture incassate", "success");
        window.location.reload();
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
      });


    refetch();
  };
  const { data: options } = useOptions("payment_schedule_status", "POST");
  return options && selectedIds ? (
    <>
      <Button
        size="small"
        color="primary"
        label="Aggiorna scadenze"
        onClick={() => setTrue()}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><BiCalendar /></>}
      </Button>
      <Dialog open={value} maxWidth="sm" fullWidth>
        <FormWithRedirect
          resource="payment_schedule_status"
          save={handleSubmit}
          initialValues={{ ids: selectedIds }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <DateInput
                  initialValue={dateFormatter(new Date())}
                  {...initInput("date", options, true)}
                />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={setFalse}>
                  <IconCancel />
                </Button>
                <FormSaveButton
                  handleSubmit={() => handleSubmitWithRedirect!()}
                  submitting={loading}
                  pristine={false}
                  label="Aggiorna data scadenza"
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  ) : null;
};
